if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"main","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(084|528|559|621|808)|2(64[48]|30|38|490|568|77|972)|3(168|90|973)|4(00|076|219|417|483|595|652|682|957)|5(5(31|55|84)|[27]44|02|338|610|91)|6(128|220|484|512|696|831|905|930)|7((30|35|51)2|[48]40|01|828|954)|8((00|18|59)4|196|212|441|465|672|767|77)|9((13|34|83)6|(48|69|72)8|032|123|689|712))$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}